import { useTranslation } from 'react-i18next';
import ManageTaskDialog from './dialog/ManageTaskDialog';
import React, { useState } from 'react';

const ManageTask: React.FC = () => {
  const { t } = useTranslation('client');
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);

  const openDialog = () => {
    setIsAddDialogOpen(true);
  };

  const closeDialog = () => {
    setIsAddDialogOpen(false);
  };

  const handleDialog = async () => {
    openDialog();
  };

  return (
    <>
      <button
        onClick={() => handleDialog()}
        className="bg-primary/50 text-primary/300 rounded-md px-5 py-2"
      >
        {t('graph.manage_task')}
      </button>
      <ManageTaskDialog
        isOpen={isAddDialogOpen}
        onClose={closeDialog}
        title={t('manage_task.title')}
      />
    </>
  );
};
export default ManageTask;
